import { render, staticRenderFns } from "./DetalheVenda.vue?vue&type=template&id=7dca4447&"
import script from "./DetalheVenda.vue?vue&type=script&lang=js&"
export * from "./DetalheVenda.vue?vue&type=script&lang=js&"
import style0 from "./DetalheVenda.vue?vue&type=style&index=0&id=7dca4447&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports